 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Popup":"Popup","changepassword":"changepassword","featuredCarousel":"featuredCarousel","sliderCarousel":"sliderCarousel","configClass":"configClass","editProfile":"editProfile","facebook popup":"facebook popup","failed popup":"failed popup","plans":"plans","purchased":"purchased","settings":"settings","success popup":"success popup","appLoader":"appLoader","featuredPlaceholder":"featuredPlaceholder","Header":"Header","popupAbout":"popupAbout","popupHelp":"popupHelp","popupPrivacy":"popupPrivacy","popupTandC":"popupTandC","hlsjs":"hlsjs","shaka":"shaka","Placeholder":"Placeholder","contentCard":"contentCard","ContentDescription":"ContentDescription","contentslider":"contentslider","dislike button":"dislike button","likebutton":"likebutton","share":"share","listContents":"listContents","intermidiate popup":"intermidiate popup","payment Popup":"payment Popup","quality Popup":"quality Popup","vLiveWebSdk":"vLiveWebSdk","userClass":"userClass","date-picker":"date-picker","HeaderMenu":"HeaderMenu","headerRight":"headerRight","formError":"formError","placeHolder":"placeHolder","sliderCarousal":"sliderCarousal","facebook-svg":"facebook-svg","twitter-svg":"twitter-svg","wallet":"wallet","dropdown":"dropdown","selectPopup":"selectPopup","search":"search","userModule":"userModule","mobilePopup":"mobilePopup","notification":"notification","popupLogin":"popupLogin","popupResetPassword":"popupResetPassword","popupSignup":"popupSignup","profileMenu":"profileMenu","logoutIconVlite":"logoutIconVlite"}[chunkId]||chunkId) + "." + {"Popup":"0a0c31f3","changepassword":"41f34371","chunk-0d0c5399":"99ea7a2a","chunk-16dc0fc6":"93627a22","chunk-2b2da625":"148a7f06","featuredCarousel":"f9fd768c","chunk-1dba4c5e":"f217e9ba","chunk-2597381e":"5bf89734","chunk-2d0d097b":"345b3d29","chunk-2d212fd5":"861db5c1","chunk-3075732e":"c95635ff","chunk-353e4619":"5e4503e1","chunk-36fb365b":"32b1af40","sliderCarousel":"73851006","chunk-3bb83709":"f2ded61a","chunk-4ede786e":"bc05aa7e","chunk-52cbdf20":"749229a8","chunk-8c80f524":"f841d795","chunk-462cc683":"38e1ad5d","chunk-47396cbb":"b54b3525","chunk-4b335cf1":"342842e4","chunk-54da03cf":"4e5d3bea","chunk-61e14a66":"b17960ad","chunk-74f991af":"96999e0a","chunk-7f396950":"ee733aba","chunk-8b7b9896":"4f0e6eea","chunk-91a53e8a":"bc0291a6","chunk-50dd26dc":"b9916516","chunk-d58ae60c":"e430bd48","chunk-dc82fa40":"59ec9ca1","chunk-de3d393e":"f99f7e4a","chunk-dfd8a6ce":"64cb2368","chunk-e05d9e4c":"1bb09597","chunk-e6a93eac":"40d70b1e","chunk-f7e3761a":"e62a68a7","configClass":"49049ca4","editProfile":"9ddd72ba","facebook popup":"6c41bbb8","failed popup":"e4240741","plans":"c9ea0bba","purchased":"57f7cf0f","settings":"5512643f","success popup":"68123730","appLoader":"08222278","featuredPlaceholder":"8f64b475","Header":"74f8076d","popupAbout":"0c8b4134","popupHelp":"786aba4a","popupPrivacy":"a878d646","popupTandC":"0416cb88","hlsjs":"516c6bd3","shaka":"74a2490b","Placeholder":"132f49a6","contentCard":"8e9fd778","ContentDescription":"9b83b850","contentslider":"858e1029","chunk-7e8bc40a":"0d17d7a0","dislike button":"f77a6139","likebutton":"1e09f475","share":"822cda17","listContents":"23e9045c","chunk-156f6496":"8c2d2e07","chunk-317846a8":"1e3313fd","chunk-743674da":"7634375e","chunk-7c603196":"15ae8512","intermidiate popup":"ff41014c","payment Popup":"70d9d1ff","quality Popup":"26cd0d51","vLiveWebSdk":"dfd94683","userClass":"464b3b21","date-picker":"6df55738","chunk-2b7e4ce4":"027ac1a2","HeaderMenu":"4b5e0c44","headerRight":"0ebf510b","formError":"97026772","placeHolder":"d50fb29b","sliderCarousal":"c34b27ea","facebook-svg":"d070ee9f","twitter-svg":"6bc64388","wallet":"5c31107a","dropdown":"f3d22b54","selectPopup":"63e5a11a","search":"eca2400a","userModule":"9a615f84","mobilePopup":"e10fe7c1","chunk-108289a8":"1b38a2e7","chunk-5020b3ef":"6cf1c4d2","notification":"d6f751bb","popupLogin":"f1391549","popupResetPassword":"cd25a975","popupSignup":"93ce0b1c","profileMenu":"11166199","chunk-2d21ecf9":"8600b1b3","logoutIconVlite":"eb29698d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Popup":1,"changepassword":1,"chunk-2b2da625":1,"featuredCarousel":1,"chunk-1dba4c5e":1,"chunk-2597381e":1,"chunk-3075732e":1,"sliderCarousel":1,"chunk-3bb83709":1,"chunk-4ede786e":1,"chunk-52cbdf20":1,"chunk-8c80f524":1,"chunk-462cc683":1,"chunk-47396cbb":1,"chunk-4b335cf1":1,"chunk-61e14a66":1,"chunk-8b7b9896":1,"chunk-d58ae60c":1,"chunk-dc82fa40":1,"chunk-de3d393e":1,"chunk-e05d9e4c":1,"chunk-e6a93eac":1,"editProfile":1,"facebook popup":1,"failed popup":1,"plans":1,"purchased":1,"settings":1,"success popup":1,"appLoader":1,"featuredPlaceholder":1,"Header":1,"popupAbout":1,"popupHelp":1,"popupPrivacy":1,"popupTandC":1,"Placeholder":1,"contentCard":1,"ContentDescription":1,"contentslider":1,"chunk-7e8bc40a":1,"dislike button":1,"likebutton":1,"share":1,"listContents":1,"chunk-156f6496":1,"chunk-317846a8":1,"chunk-743674da":1,"chunk-7c603196":1,"intermidiate popup":1,"payment Popup":1,"quality Popup":1,"chunk-2b7e4ce4":1,"HeaderMenu":1,"headerRight":1,"formError":1,"placeHolder":1,"sliderCarousal":1,"facebook-svg":1,"twitter-svg":1,"wallet":1,"dropdown":1,"selectPopup":1,"search":1,"userModule":1,"mobilePopup":1,"chunk-108289a8":1,"chunk-5020b3ef":1,"notification":1,"popupLogin":1,"popupResetPassword":1,"popupSignup":1,"profileMenu":1,"logoutIconVlite":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Popup":"Popup","changepassword":"changepassword","featuredCarousel":"featuredCarousel","sliderCarousel":"sliderCarousel","configClass":"configClass","editProfile":"editProfile","facebook popup":"facebook popup","failed popup":"failed popup","plans":"plans","purchased":"purchased","settings":"settings","success popup":"success popup","appLoader":"appLoader","featuredPlaceholder":"featuredPlaceholder","Header":"Header","popupAbout":"popupAbout","popupHelp":"popupHelp","popupPrivacy":"popupPrivacy","popupTandC":"popupTandC","hlsjs":"hlsjs","shaka":"shaka","Placeholder":"Placeholder","contentCard":"contentCard","ContentDescription":"ContentDescription","contentslider":"contentslider","dislike button":"dislike button","likebutton":"likebutton","share":"share","listContents":"listContents","intermidiate popup":"intermidiate popup","payment Popup":"payment Popup","quality Popup":"quality Popup","vLiveWebSdk":"vLiveWebSdk","userClass":"userClass","date-picker":"date-picker","HeaderMenu":"HeaderMenu","headerRight":"headerRight","formError":"formError","placeHolder":"placeHolder","sliderCarousal":"sliderCarousal","facebook-svg":"facebook-svg","twitter-svg":"twitter-svg","wallet":"wallet","dropdown":"dropdown","selectPopup":"selectPopup","search":"search","userModule":"userModule","mobilePopup":"mobilePopup","notification":"notification","popupLogin":"popupLogin","popupResetPassword":"popupResetPassword","popupSignup":"popupSignup","profileMenu":"profileMenu","logoutIconVlite":"logoutIconVlite"}[chunkId]||chunkId) + "." + {"Popup":"b07c7a3d","changepassword":"d260042c","chunk-0d0c5399":"31d6cfe0","chunk-16dc0fc6":"31d6cfe0","chunk-2b2da625":"af69a26c","featuredCarousel":"d891a361","chunk-1dba4c5e":"79bedbc3","chunk-2597381e":"b5d5f42f","chunk-2d0d097b":"31d6cfe0","chunk-2d212fd5":"31d6cfe0","chunk-3075732e":"66835b00","chunk-353e4619":"31d6cfe0","chunk-36fb365b":"31d6cfe0","sliderCarousel":"f3d96f98","chunk-3bb83709":"6b499d25","chunk-4ede786e":"ecc6cc8e","chunk-52cbdf20":"7eecc998","chunk-8c80f524":"52778521","chunk-462cc683":"bcb15610","chunk-47396cbb":"c78efb89","chunk-4b335cf1":"a4a8b50f","chunk-54da03cf":"31d6cfe0","chunk-61e14a66":"ee77d87d","chunk-74f991af":"31d6cfe0","chunk-7f396950":"31d6cfe0","chunk-8b7b9896":"61073fd2","chunk-91a53e8a":"31d6cfe0","chunk-50dd26dc":"31d6cfe0","chunk-d58ae60c":"72f24373","chunk-dc82fa40":"650cc167","chunk-de3d393e":"05414349","chunk-dfd8a6ce":"31d6cfe0","chunk-e05d9e4c":"d369e8a8","chunk-e6a93eac":"fd7a1ac9","chunk-f7e3761a":"31d6cfe0","configClass":"31d6cfe0","editProfile":"e4af0b8f","facebook popup":"b45e2065","failed popup":"8b1be6e6","plans":"d9f590a4","purchased":"ecf019ea","settings":"3d7b2564","success popup":"9616b541","appLoader":"9de9265f","featuredPlaceholder":"b3890f95","Header":"3b875982","popupAbout":"88138c4b","popupHelp":"11521a2d","popupPrivacy":"bd10dcc3","popupTandC":"17d88f15","hlsjs":"31d6cfe0","shaka":"31d6cfe0","Placeholder":"2a7017b7","contentCard":"ae806fd5","ContentDescription":"ff7258bc","contentslider":"fa4bf69a","chunk-7e8bc40a":"8c63eca4","dislike button":"28fab7c0","likebutton":"ec5a6fb0","share":"872ff31d","listContents":"957faab1","chunk-156f6496":"166fad04","chunk-317846a8":"726c3b24","chunk-743674da":"6688c4f6","chunk-7c603196":"9b76fc29","intermidiate popup":"cf239401","payment Popup":"3c0e10c8","quality Popup":"8e5140d3","vLiveWebSdk":"31d6cfe0","userClass":"31d6cfe0","date-picker":"31d6cfe0","chunk-2b7e4ce4":"2654ea0b","HeaderMenu":"9a8f9710","headerRight":"5ea9cea7","formError":"b629469e","placeHolder":"893243d0","sliderCarousal":"718304d8","facebook-svg":"3122e211","twitter-svg":"b1007c67","wallet":"2b12e898","dropdown":"54f4b538","selectPopup":"2045e91d","search":"5f8922f9","userModule":"93d95df0","mobilePopup":"36d6d008","chunk-108289a8":"5cb16b3b","chunk-5020b3ef":"5d843608","notification":"7e1939d3","popupLogin":"44a7dfc2","popupResetPassword":"b382b216","popupSignup":"990b7938","profileMenu":"bbb012e5","chunk-2d21ecf9":"31d6cfe0","logoutIconVlite":"2a47b66a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
